export default "__VITE_ASSET__CkE1Iqz0__"